import { createAction, props } from "@ngrx/store";

const setUrlIsPublic    = createAction('[Onboarding] setFirstFundingUser',props<{isUrlPublic:boolean}>());


const routesActions = {
    setUrlIsPublic
}

export default routesActions